import { dateUtils, citizenshipEntity } from 'shared';
import type { Accounts } from '@aviata/platform-types';

export const mapSavedPassenger = (passenger: Accounts.Passenger) => ({
  id: passenger.id,
  firstName: passenger.first_name,
  lastName: passenger.last_name,
  gender: passenger.gender,
  dob: dateUtils.dateFromAccountsFormat(passenger.dob),
  citizenship: passenger.citizenship,
  document: {
    expiresAt: passenger.document_expires_at
      ? dateUtils.dateFromAccountsFormat(passenger.document_expires_at)
      : '',
    number: passenger.document_number,
    type: passenger.document_type,
    givenAt: passenger.document_issued_date
      ? dateUtils.dateFromAccountsFormat(passenger.document_issued_date)
      : '',
    organization: passenger.document_issued_by,
    series: passenger.document_series,
  },
  airlineBonusCard: '',
  iin:
    passenger.citizenship === citizenshipEntity.config.KAZAKHSTAN_CODE
      ? passenger.national_id
      : '',
  fin:
    passenger.citizenship === citizenshipEntity.config.AZERBAIJAN_CODE
      ? passenger.fin
      : '',
});
